import React, { useEffect, useState } from 'react';
import { Button, Tabs } from 'antd';
import './tabs.css'
import TableUserMember from '../../pages/member-pages/TableUser';
import { useTranslation } from 'react-i18next';
import TableMember from '../../pages/member-pages/TableMember';
import { getDataRequest } from '../../api/serviceMethods';
import { MEMBER_URL } from '../../api/URLs';
import { useNavigate } from 'react-router-dom';
import TableSuperMember from '../../pages/member-pages/TableSuperMember';
import { RiSettingsLine } from "react-icons/ri";
import MemberSettingModal from '../magazine/MemberSettingModal';

const TableUserManagerment = ({ messageModalRef,loading, setLoading }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [keyword, setKeyword] = useState('');
    const [memberData, setMemberData] = useState([])
    const [dates, setDates] = useState([null, null]);
    const [memberType, setMemberType] = useState('normal');
    const [isSearch, setIsSearch] = useState(true)
    const [modalOpen, setModalOpen] = useState(false)
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });
    
    const initLoadMember = async () => {
        setLoading(true);
        await getDataRequest(`${MEMBER_URL}`, {
            keyword: keyword.trim(),
            startRegDate: dates[0] || "",
            endRegDate: dates[1] || "",
            memberType: memberType === "pro" ? "pro" : memberType === "VIP" ? "VIP" : ["normal", "trial"],
            // memberType === "pro" ? "pro" : ["normal", "trial"],
            sortKeys: { [tableParams.sortField ? tableParams.sortField : "createdTS"]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
            pageNo: tableParams.pagination.current,
            pageSize: tableParams.pagination.pageSize,
        }).then(res => {
            setLoading(false);
            if (res.status === 200) {
                setMemberData(res?.data);
                setTableParams(prevParams => ({
                    ...prevParams,
                    pagination: {
                        ...prevParams.pagination,
                        total: res.total,
                    },
                }));
            }
        }).catch((err) => {
            setLoading(false);
            console.log("Error", err);
        });
    };
    const handleTabChange = (activeKey) => {
        setTableParams(prevParams => ({
            ...prevParams,
            pagination: {
                ...prevParams.pagination,
                current: 1,
            },
        }));
        if (activeKey === 'listUsers') {
            setMemberType('normal');
            setKeyword("")
        }
        else if (activeKey === 'memberList') {
            setMemberType('pro');
            setKeyword("")
        }
        else if (activeKey === 'superMemberList') {
            setMemberType('VIP');
            setKeyword("")
        }
    };

    const handleClickEdit = (item) => {
        navigate(`/user/details?id=${item.memberId}`);
    };

    const handleClickEditPro = (item) => {
        navigate(`/member/details?id=${item.memberId}`);
    };
    useEffect(() => {
        isSearch && initLoadMember();
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        JSON.stringify(tableParams.filters), isSearch, memberType
    ]);

    return (
        <>
        <Tabs 
            defaultActiveKey="listUsers" 
            className="cusStyle" 
            onChange={handleTabChange}
            tabBarExtraContent={{
                right: (
                    <Button
                        icon={<RiSettingsLine />}
                        className=''
                        type="text"
                        onClick={() => setModalOpen(true)}
                        style={{
                            fontSize: '16px',
                            marginRight: "1.5rem",
                            color: "#e72158",
                            border: "1px solid #e72158"
                        }}
                    >
                        {t('Member Setting')}
                    </Button>
                ),
            }}
        >
            <Tabs.TabPane tab={t("User List")} key="listUsers">
                <TableUserMember
                    messageModalRef={messageModalRef}
                    memberData={memberData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    initLoadMember={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                          setIsSearch(true)
                        }, 100);
                      }}
                    memberType={memberType}
                    handleClickEdit={handleClickEdit}
                />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("Member List")} key="memberList">
                <TableMember
                    messageModalRef={messageModalRef}
                    memberData={memberData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    initLoadMember={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                          setIsSearch(true)
                        }, 100);
                      }}
                    memberType={memberType}
                    handleClickEditPro={handleClickEditPro}
                />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t("Super Member List")} key="superMemberList">
                <TableSuperMember
                    messageModalRef={messageModalRef}
                    memberData={memberData}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    tableParams={tableParams}
                    setTableParams={setTableParams}
                    dates={dates}
                    setDates={setDates}
                    initLoadMember={() => {
                        setIsSearch(false)
                        setTimeout(() => {
                          setIsSearch(true)
                        }, 100);
                      }}
                    memberType={memberType}
                    handleClickEditPro={handleClickEditPro}
                />
            </Tabs.TabPane>
        </Tabs>
        <MemberSettingModal
            setModalOpen={setModalOpen}
            modalOpen={modalOpen}
        />
        </>
    )
}
export default TableUserManagerment;